'use-strict';

/* @ngInject */
export default function WorkflowEventsController(
  $scope,
  $location,
  monitoringApiService,
  interfaceService,
  NgTableParams,
) {
  const self = this;
  $scope.events = null;
  $scope.adminEvents = null;

  const getUserEvents = () => {
    monitoringApiService.apiGetEvents()
      .then((events) => {
        events.forEach((e) => {
          if (!e.assigned_users) return;
          e.assigned_users = e.assigned_users.split(',');
        });

        $scope.events = events;
        self.table.settings({
          dataset: events,
        });
        interfaceService.applyScope($scope);
      })
      .catch((e) => console.error(e));
  };

  const getAllEvents = () => {
    monitoringApiService.apiGetAllEvents()
      .then((events) => {
        events.forEach((e) => {
          if (!e.assigned_users) return;
          e.assigned_users = e.assigned_users.split(',');
        });

        $scope.adminEvents = events;
        self.adminTable.settings({
          dataset: events,
        });
        interfaceService.applyScope($scope);
      })
      .catch((e) => console.error(e));
  };

  const init = () => {
    self.table = new NgTableParams({
      sorting: {
        id: 'desc',
      },
    });

    self.adminTable = new NgTableParams({
      sorting: {
        id: 'desc',
      },
    });

    getUserEvents();
  };

  $scope.changeRailItem = (item) => {
    if (item === 'Alle') getAllEvents();
  };

  /**
   * Remove all applied filters from table
   */
  $scope.removeAllFilter = () => {
    self.table.filter({});
    $scope.filteredTableData = $scope.cars;
  };

  /**
   * Remove the supplied filter from the view's table.
   * @param {Object} filter
   */
  $scope.removeFilter = (filter) => {
    delete self.table.filter()[filter];
  };

  init();
}
